import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const companyApiUrl = `${baseApiUrl}/api/Company`;

export async function getCompanies() {
    return await httpRequest(fetchCompanies.bind(this));
}

async function fetchCompanies() {
    let config = getHttpHeaders();
    return await axios.get(`${companyApiUrl}`, config);
}

export async function updateCompany(company) {
    return await httpRequest(putCompany.bind(this, company));
}

async function putCompany(company) {
    let config = getHttpHeaders();
    return await axios.put(`${companyApiUrl}`, company, config);
}

export async function addCompany(newcompany) {
    return await httpRequest(postCompany.bind(this, newcompany));
}

async function postCompany(newcompany) {
    let config = getHttpHeaders();
    return await axios.post(`${companyApiUrl}`, newcompany, config);
}

export async function deleteCompany(id) {
    return await httpRequest(fetchDeleteCompany.bind(this, id));
}

async function fetchDeleteCompany(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${companyApiUrl}/${id}`, config);
}
